import http from '@/utils/http';

const baseUrl = '/rastreabilidade/nota-fiscal';

export default {

    buscar(filtros, paginacao) {
        let textoBusca = '';
        if (filtros !== '') {
            textoBusca = filtros.textoBusca;
        }
        const { direcao, itensPorPagina, ordernarPor, pagina } = paginacao;
        let url =
            baseUrl + '?texto-busca=' + textoBusca + '&pagina=' + pagina;

        if (direcao !== null && direcao !== undefined) {
            url += '&direcao=' + direcao;
        }

        if (itensPorPagina !== null && itensPorPagina !== undefined) {
            url += '&itens-por-pagina=' + itensPorPagina;
        }

        if (ordernarPor !== null && ordernarPor !== undefined) {
            url += '&ordenar-por=' + ordernarPor;
        }

        return http.get({
            url: url,
            lockScreen: true,
            lockMessage: 'Buscando Notas Fiscais'
        });
    },

    pesquisar(filtro) {
        return http.get({
            url: baseUrl + `/buscar?filtro=${filtro}`,
            lockScreen: false
        });
    },

    buscarNotaFiscal() {
        return http.get({
            url: baseUrl + `/buscar?filtro=`,
            lockScreen: false
        });
    },

    buscarTotalizadoresNotaFiscal() {
        return http.get({
            url: baseUrl + `/totalizadores`,
            lockScreen: false
        });
    },

    editarNotaFiscal(payload) {
        return http.post({
            url: baseUrl + '/editar',
            data: payload,
            lockScreen: true
        });
    },

    excluirNotaFiscal(payload) {
        return http.post({
            url: baseUrl + '/excluir',
            data: payload,
            lockScreen: true
        });
    },

    buscarPorId(id) {
        let url =
            baseUrl + '/buscar-por-id' + '?id=' + id;

        return http.get({
            url: url,
            lockScreen: true,
            lockMessage: 'Buscando Nota Fiscal'
        });
    },

    buscarFazendasNotaFiscal(textoBusca, paginacao) {
        const { direcao, itensPorPagina, ordernarPor, pagina } = paginacao;
        let url =
            baseUrl + '/buscar-fazendas-nota-fiscal' + '?id=' + textoBusca + '&pagina=' + pagina;

        if (direcao !== null && direcao !== undefined) {
            url += '&direcao=' + direcao;
        }

        if (itensPorPagina !== null && itensPorPagina !== undefined) {
            url += '&itens-por-pagina=' + itensPorPagina;
        }

        if (ordernarPor !== null && ordernarPor !== undefined) {
            url += '&ordenar-por=' + ordernarPor;
        }

        return http.get({
            url: url,
            lockScreen: true,
            lockMessage: 'Buscando Notas Fiscais'
        });
    },

    buscarPorFazenda(codigoFazenda, paginacao) {
        const { direcao, itensPorPagina, ordernarPor, pagina } = paginacao;
        let url =
            baseUrl + '/buscar-por-fazenda' + '?codigo-fazenda=' + codigoFazenda + '&pagina=' + pagina;

        if (direcao !== null && direcao !== undefined) {
            url += '&direcao=' + direcao;
        }

        if (itensPorPagina !== null && itensPorPagina !== undefined) {
            url += '&itens-por-pagina=' + itensPorPagina;
        }

        if (ordernarPor !== null && ordernarPor !== undefined) {
            url += '&ordenar-por=' + ordernarPor;
        }

        return http.get({
            url: url,
            lockScreen: true,
            lockMessage: 'Buscando Notas Fiscais'
        });
    },

    buscarPorNumeroEdata(codigoFazenda, filtros, dataInicio, dataFim, paginacao) {
        let textoBusca = '';
        if (filtros !== '') {
            textoBusca = filtros.textoBusca;
        }
        const { direcao, itensPorPagina, ordernarPor, pagina } = paginacao;
        let url =
            baseUrl +
             '/buscar-por-numero-data' +
              '?codigo-fazenda=' + codigoFazenda +
              '&numero-nota-fiscal=' + textoBusca +
              '&data-inicio=' + dataInicio +
              '&data-fim=' + dataFim +
               '&pagina=' + pagina;

        if (direcao !== null && direcao !== undefined) {
            url += '&direcao=' + direcao;
        }

        if (itensPorPagina !== null && itensPorPagina !== undefined) {
            url += '&itens-por-pagina=' + itensPorPagina;
        }

        if (ordernarPor !== null && ordernarPor !== undefined) {
            url += '&ordenar-por=' + ordernarPor;
        }

        return http.get({
            url: url,
            lockScreen: true,
            lockMessage: 'Buscando Notas Fiscais'
        });
    }

};
